import React from "react";

import { Box, Typography, Divider } from "@mui/material";
import { StaticDateTimePicker } from "@mui/x-date-pickers";
import { format, addDays } from "date-fns";

const DatePicker = ({
	fieldValueState,
	setFieldValueState
}: {
	fieldValueState: Date | null;
	setFieldValueState: React.Dispatch<React.SetStateAction<Date | null>>;
}) => {
	const formattedDateTime = fieldValueState ? format(fieldValueState, "PPp") : "";
	return (
		<Box display={"flex"} flexDirection={"column"}>
			<StaticDateTimePicker
				value={fieldValueState ? new Date(fieldValueState) : new Date()}
				onChange={newValue => {
					setFieldValueState(newValue);
				}}
				slotProps={{ actionBar: { actions: [] } }}
				minDateTime={addDays(new Date(), 1)}
			/>

			<Divider sx={{ mt: 4 }} />
			<Box mt={4} display={"flex"} justifyContent={"center"}>
				{formattedDateTime && <Typography>{formattedDateTime}</Typography>}
			</Box>
		</Box>
	);
};

export default DatePicker;
